import { useReadContracts } from "wagmi";
import useDappConfig from "./useDappConfig";
import { useMemo } from "react";
import { mainnet } from "viem/chains";
import { formatEther } from "@ethersproject/units";

const useAgEthExchangeRate = () => {
  const { vaultsContractConfig } = useDappConfig();

  const exchangeRateContracts = useMemo(() => {
    const contracts = [];
    const vaultConfig = vaultsContractConfig[mainnet.id]?.interactionPool;

    //Deposit
    contracts.push({
      ...vaultConfig,
      functionName: "convertToShares",
      args: [1000000000000000000],
      chainId: mainnet.id,
    });

    //Withdraw
    contracts.push({
      ...vaultConfig,
      functionName: "convertToAssets",
      args: [1000000000000000000],
      chainId: mainnet.id,
    });

    return contracts;
  }, [vaultsContractConfig]);

  const { data, isLoading } = useReadContracts({
    contracts: exchangeRateContracts,
    query: {
      refetchInterval: 90_000,
    },
  });

  /*
    toShare -> Deposit (fromERC20)
    toAsset -> Withdraw (toERC20)
 */

  const exchangeData = useMemo(() => {
    if (data) {
      return {
        fromERC20: data[0]?.result && formatEther(data[0]?.result as bigint),
        toERC20: data[1]?.result && formatEther(data[1]?.result as bigint),
        isLoading,
      };
    }
    return { fromERC20: 0, toERC20: 0, isLoading };
  }, [data]);

  return exchangeData;
};

export default useAgEthExchangeRate;
